<form (ngSubmit)="onSubmit()" [formGroup]="form" [ngClass]="{ 'with-borders': !showButtons }">
  <div [hidden]="!loading" class="spinner" [ngClass]="{ 'h-75': !showButtons }">
    <div class="sk-spinner sk-spinner-pulse"></div>
  </div>
  <div class="create-test-topbar d-flex align-items-center flex-wrap py-15 px-20">
    <div class="left-col d-flex align-items-center max-w-[300px] me-20">
      <h3 class="me-20 mb-0">Create test</h3>
      <div *ngIf="showButtons" class="dropdown template-dropdown" [ngClass]="testCaseTemplateId ? 'template-selected' : ''">
        <div tooltip="Test Templates include all your test settings, such as content, suppliers, destinations and any other settings you’ve selected"
          class="dropdown-toggle" href="#" role="button" id="dropdownMenuLink" data-bs-toggle="dropdown">
          <ng-container *ngIf="testCaseTemplateId; else elseBlock">
            <i class="template-icon icon-templates-1"></i>
            <div class="template-title">{{ testCaseTemplateTitle }}</div>
          </ng-container>
          <ng-template #elseBlock>
            <div class="template-title">Templates</div>
          </ng-template>
        </div>

        <ul class="dropdown-menu px-0 py-0_8 rounded-15 bg-neutral-n1" aria-labelledby="dropdownMenuLink">
          <li class="px-15 py-10 drop-title">Use saved test template</li>
          <div class="test-case-template-list-container" *ngIf="templatesList.length > 0; else noTemplatePresentBlock">
            <a class="dropdown-item px-15 py-10 cp" [ngClass]="{ active: t.id === testCaseTemplateId }" *ngFor="let t of templatesList"
              (click)="setTemplateTestCaseId(t.id)">{{ t.title }}
              <span *ngIf="t.isDefault" [ngClass]="{ 'text-primary': t.id !== testCaseTemplateId }">(Default)</span>
            </a>
          </div>
          <ng-template #noTemplatePresentBlock>
            <li class="pe-none">
              <a class="dropdown-item px-15 py-10">No templates present</a>
            </li>
          </ng-template>
        </ul>
      </div>
      <div>
        <a tooltip="Save/update test case template" *ngIf="showButtons" (click)="onClickTestCaseTemplateSaveAs()" class="rounded-icon with-border mx-10"
          [ngClass]="{ 'show-dropdown': testCaseTemplateId }"><span class="far fa-save"></span></a>
        <div class="save-actions">
          <ul>
            <li>
              <a class="cp" (click)="onClickTestCaseTemplateSaveAs()">
                <i class="far fa-save"></i> Save as new template
              </a>
            </li>
            <li>
              <a class="cp" (click)="onClickTestCaseTemplateSave()">
                <i class="icon-test-sender-id-replaced"></i> Update existing template
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="right-col d-flex align-items-center flex-grow-1 justify-content-end">
      <a tooltip="Clear all test settings" tooltipPlacement="bottom" class="rounded-icon mr-5" (click)="resetAllSelectedValues()">
        <i class="far fa-trash-alt"></i>
      </a>

      <a tooltip="Test settings" tooltipPlacement="bottom" class="rounded-icon" (click)="openTestSettingsModal()"><span class="icon-settings"
          [ngClass]="{ applied: isLNTSettingsApplied() }"></span></a>

      <div class="v-line"></div>

      <div class="inc-dec-box d-flex align-items-center bg-neutral-n1 me-0_8">
        <span tooltip="Issue the current test batch multiple times at once" tooltipPlacement="bottom" class="icon-refresh me-0_7 icon"></span>
        <input [(ngModel)]="model.testRepeatsPerIteration" (ngModelChange)="calculateCountResults()" formControlName="testRepeatsPerIteration" type="number"
          min="1" max="999" step="1" class="form-control inc-dec-input" />
      </div>

      <div class="button-group">
        <button *ngIf="showButtons" type="submit" [disabled]="!valid || loading" class="btn btn-primary px-20 btn-text">
          Run
          <span *ngIf="countResults">(<span id="tests-count-label">{{ countResults }}</span>)</span>
        </button>
        <button tooltip="Set up a Scheduled task with the current test settings" tooltipPlacement="bottom" *ngIf="showButtons"
          class="btn btn-primary px-10 btn-icon ms-0_1" [disabled]="!valid || loading" (click)="onClickScheduleButton($event)">
          <span class="icon-calendar"></span>
        </button>
      </div>
    </div>
  </div>

  <div class="create-test-body">
    <div class="create-test-box-wrapper d-flex flex-wrap">
      <div class="create-test-box-holder">
        <div class="create-test-box px-20 py-20">
          <app-lnt-content-templates (changedCount)="calculateCountResults()" [form]="form"></app-lnt-content-templates>
        </div>
      </div>
      <div class="create-test-box-holder">
        <div class="create-test-box px-20 py-20">
          <app-destinations-select [recent]="false" [flashCallAvailable]="flashCallAvailable" (onChange)="calculateCountResults()"
            (flashCallSelected)="onFlashCallSelected()"></app-destinations-select>
        </div>
      </div>
      <div class="create-test-box-holder">
        <div class="create-test-box px-20 py-20">
          <app-routes-select (onChange)="calculateCountResults()"></app-routes-select>
        </div>
      </div>
    </div>
  </div>
</form>

<ng-template #templateSaveModalTpl let-dialogRef="dialogRef">
  <div class="modal-header">
    <div class="modal-title">
      <h3>Enter title for the template</h3>
      <button type="button" class="btn-close" (click)="dialogRef.close(true)">
        <span class="icon-close"></span>
      </button>
    </div>
  </div>
  <div class="modal-body">
    <div [hidden]="!loading" class="spinner">
      <div class="sk-spinner sk-spinner-pulse small"></div>
    </div>
    <form [formGroup]="templateSaveForm" class="mt-20 mb-20">
      <div class="form-group">
        <input formControlName="templateTitle" type="text" class="form-control" placeholder="Template Title" (keyup)="onTestTemplateKeyUp()" />
        <input-errors [control]="templateSaveForm.controls.templateTitle" [service]="validationService"></input-errors>
      </div>
    </form>
    <div class="alert alert-warning" *ngIf="isTemplateNameDuplicate">
      <b>The test template title that you have entered already exists. Do you want to overwrite it?</b>
    </div>
  </div>
  <div class="modal-footer pt-15">
    <div class="button-holder d-flex justify-content-between">
      <button class="btn btn-outline-dark" (click)="onTemplateSaveFormCancel(dialogRef)">Cancel</button>
      <button *ngIf="!isTemplateNameDuplicate" class="btn btn-primary ms-15" type="submit" (click)="onSubmitTemplateSave(dialogRef)"
        [disabled]="!isTemplateSaveValid()">
        Save
      </button>
      <button *ngIf="isTemplateNameDuplicate" class="btn btn-primary ms-15" type="submit" (click)="onClickTestCaseTemplateSave(dialogRef)"
        [disabled]="!isTemplateSaveValid()">
        Yes, overwrite
      </button>
    </div>
  </div>
</ng-template>

<ng-template #confirmModalTpl let-dialogRef="dialogRef">
  <div class="modal-header mb-10">
    <div class="modal-title">
      <h3 class="d-inline-block">Test summary</h3>
      <button type="button" class="btn-close" (click)="dialogRef.close(false)">
        <span class="icon-close"></span>
      </button>
    </div>
  </div>
  <div class="modal-body">
    <div [hidden]="!loading" class="spinner">
      <div class="sk-spinner sk-spinner-pulse"></div>
    </div>

    <div class="d-flex modal-tabs-vertical">
      <ul class="nav flex-column">
        <div (click)="scrollTo('contentTexts')">
          <a class="nav-link cp" [ngClass]="{ active: currentSection === 'contentTexts' }">
            <span class="nav-text"> Content</span>
          </a>
        </div>
        <div (click)="scrollTo('countries')">
          <a class="nav-link cp" [ngClass]="{ active: currentSection === 'countries' }">
            <span class="nav-text"> Destinations</span>
          </a>
        </div>
        <div (click)="scrollTo('connections')">
          <a class="nav-link cp" [ngClass]="{ active: currentSection === 'connections' }">
            <span class="nav-text"> Suppliers</span>
          </a>
        </div>
        <div (click)="scrollTo('flashCall')" *ngIf="isFlashCallMode()">
          <a class="nav-link cp" [ngClass]="{ active: currentSection === 'flashCall' }">
            <span class="nav-text"> Flash call detection</span>
          </a>
        </div>
        <div (click)="scrollTo('comment')" *ngIf="model.commentText?.length > 0">
          <a class="nav-link cp" [ngClass]="{ active: currentSection === 'comment' }">
            <span class="nav-text"> Comment</span>
          </a>
        </div>
      </ul>

      <div class="tab-content section-parent" id="parentDiv" scrollSpy [spiedTags]="['DIV']" (sectionChange)="onSectionChange($event)">
        <div id="contentTexts" class="section-child">
          <ul class="modal-tab-list modal-tab-table-list">
            <li class="title mb-10">{{ contentTemplates.getContentTexts().length }} content text</li>
            <div class="py-0_7" *ngFor="let template of contentTemplates.getContentTexts()">
              <strong>{{ template.senderId }}</strong>&nbsp;
              <i class="icon-link" [ngClass]="{ custom: !template.fromServer }"></i>
              &nbsp;<span>{{ template.text }}</span>
            </div>
          </ul>
        </div>
        <div id="countries" class="section-child">
          <ul class="modal-tab-list modal-tab-table-list">
            <li class="title mb-10">{{ countries.getSelectedModels(false).length }} destination</li>
            <div class="py-0_7" *ngFor="let country of countries.getSelectedModels(false)">
              <span *ngIf="!country.custom">{{ country.countryName }}({{ country.mcc }})/{{ country.providerName }}({{
                country.mnc
                }})</span>
              <span *ngIf="!country.custom && country.originalMnc">
                <i class="icon-ported"></i> {{ country.originalProviderName }}({{
                country.originalMnc
                }})</span>
              <span *ngIf="country.custom">{{ country.phonenumber }}</span>
              <span *ngIf="model.testRepeatsPerIteration"> x{{ model.testRepeatsPerIteration }}</span>
            </div>
          </ul>
        </div>
        <div id="connections" class="section-child">
          <ul class="modal-tab-list modal-tab-table-list">
            <li class="title mb-10">{{ connections.getSelectedModels().length }} supplier</li>
            <div class="py-0_7" *ngFor="let connection of connections.getSelectedModels()">
              <span>
                {{ connection.title }}/{{ connection.routeType }}
                <span *ngIf="connection.comment" class="text-neutral-n7">({{ connection.comment }})</span>
              </span>
            </div>
          </ul>
        </div>

        <div id="flashCall" class="section-child" *ngIf="isFlashCallMode()">
          <ul class="modal-tab-list modal-tab-table-list">
            <li class="title mb-10">Flash call detection</li>
            <div class="py-0_7">Enabled</div>
            <div class="py-0_7">TTL: {{ flashCallTtlLabel }}</div>
            <div class="py-0_7">Test ID Text: {{ flashCallTestIdLabel }}</div>
          </ul>
        </div>

        <div id="comment" class="section-child" *ngIf="model.commentText?.length > 0">
          <ul class="modal-tab-list modal-tab-table-list">
            <li class="title mb-10">Comment</li>
            <span>{{ model.commentText }}</span>
          </ul>
        </div>
        <!-- This below element is needed to have last section in focus when scrolling ... -->
        <div class="section-empty-child"></div>
      </div>
    </div>
  </div>

  <div class="modal-footer pt-15">
    <div class="button-holder d-flex justify-content-between">
      <div class="d-flex justify-content-start gap-15">
        <button class="btn btn-outline-dark" (click)="dialogRef.close(false)">Cancel</button>
        <button class="btn btn-outline-primary" (click)="onClickScheduleButton($event)">
          Schedule for later
        </button>
      </div>

      <div class="d-flex justify-content-end align-items-center">
        <h5 class="mb-0" [ngClass]="{ 'error-blink': this.testsPrice > 50 }">
          {{ this.countResults }} <span>tests for</span> € {{ this.testsPrice }}
        </h5>

        <button class="btn btn-primary ms-15" *ngIf="this.testsPrice < 50; else slideToConfirmBlock" (click)="dialogRef.close(true)"
          [disabled]="!valid || loading">
          Confirm
        </button>
        <ng-template #slideToConfirmBlock>
          <app-slide-button (onConfirmSwipe)="onConfirmSwipe($event)"></app-slide-button>
        </ng-template>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #testSettingsModalTpl let-dialogRef="dialogRef">
  <div class="modal-header mb-10">
    <div class="modal-title">
      <h3 class="d-inline-block">Settings</h3>
      <button type="button" class="btn-close" (click)="dialogRef.close(false)">
        <span class="icon-close"></span>
      </button>
    </div>
  </div>
  <div class="modal-body setting-body">
    <ul class="nav nav-pills mb-3 setting-tabs" id="pills-tab22" role="tablist">
      <li class="nav-item" role="presentation">
        <button class="nav-link active" id="sender-tab" data-bs-toggle="pill" data-bs-target="#pills-sender" type="button" role="tab"
          aria-controls="pills-sender" aria-selected="true">
          Sender ID & Content
        </button>
      </li>
      <li class="nav-item" role="presentation">
        <button class="nav-link" id="timing-tab" data-bs-toggle="pill" data-bs-target="#pills-timing" type="button" role="tab" aria-controls="pills-timing"
          aria-selected="false">
          Timing and Delivery
        </button>
      </li>
      <li class="nav-item" role="presentation">
        <button class="nav-link" id="udh-tab" data-bs-toggle="pill" data-bs-target="#pills-udh" type="button" role="tab" aria-controls="pills-udh"
          (click)="onClickUdhTab()" aria-selected="false">
          UDH
        </button>
      </li>
      <li class="nav-item" role="presentation">
        <button class="nav-link" id="tlv-tab" data-bs-toggle="pill" data-bs-target="#pills-tlv" type="button" role="tab" aria-controls="pills-tlv"
          (click)="onClickTlvTab()" aria-selected="false">
          TLV
        </button>
      </li>
      <li class="nav-item" role="presentation">
        <button class="nav-link" id="comment-tab" data-bs-toggle="pill" data-bs-target="#pills-comment" type="button" role="tab" aria-controls="pills-comment"
          aria-selected="false">
          Comment
        </button>
      </li>
    </ul>
    <form [formGroup]="form">
      <div class="tab-content setting-content" id="pills-tabContent">
        <div class="tab-pane fade show active" id="pills-sender" role="tabpanel" aria-labelledby="sender-tab">
          <div class="alert alert-primary" role="alert">
            This menu allows you to customize the sender ID and content characteristics of your test. By
            default, "Automatic", our system will determine the appropriate settings based on the sender ID
            and content of your SMS.
            <br /><br />You can manually set these values to override the automatic selection.
          </div>
          <div class="form-group">
            <label class="form-label">
              Source TON
              <span class="icon-help-1 text-neutral-n6" [tooltip]="
                                    'Source TON (Type of Number) defines the type of number used in the `source_addr` field as per the SMPP protocol. This value can be set manually from the dropdown menu, where you can find the hexadecimal value and its English equivalent. <br>If `Automatic` is selected, the system determines the appropriate TON based on the format of the sender ID. Click here to read more.'
                                " [tooltipPlacement]="'top'" [tooltipClass]="'text-start'"></span>
            </label>
            <select [(ngModel)]="model.ton" formControlName="ton" class="form-control form-select input-sm">
              <option *ngFor="let item of tonItems" [value]="item.id">{{ item.label }}</option>
            </select>
            <input-errors [control]="form.controls.ton" [service]="validationService"></input-errors>
          </div>
          <div class="form-group">
            <label class="form-label">
              Source NPI
              <span class="icon-help-1 text-neutral-n6" [tooltip]="
                                    'Source NPI (Numbering Plan Indicator) determines the numbering plan used in the `source_addr` field of the SMPP protocol. This value can be set manually from the dropdown menu, where you can find the hexadecimal value and its English equivalent. <br>If `Automatic` is selected, the system determines the appropriate NPI based on the format of the sender ID. Click here to read more.'
                                " [tooltipPlacement]="'top'" [tooltipClass]="'text-start'"></span>
            </label>
            <select [(ngModel)]="model.npi" formControlName="npi" class="form-control form-select input-sm">
              <option *ngFor="let item of npiItems" [value]="item.id">{{ item.label }}</option>
            </select>
            <input-errors [control]="form.controls.npi" [service]="validationService"></input-errors>
          </div>
          <div class="form-group">
            <label class="form-label">
              Data Coding
              <span class="icon-help-1 text-neutral-n6" [tooltip]="
                                    'Data Coding defines the encoding scheme for the message content, which affects how special characters are handled. The options in the dropdown menu are displayed in hexadecimal format along with their English description. <br>By default,  `Automatic`, our system will select the appropriate data coding based on the content of the message.'
                                " [tooltipPlacement]="'top'" [tooltipClass]="'text-start'"></span>
            </label>
            <select [(ngModel)]="model.dcs" formControlName="dcs" class="form-control form-select input-sm">
              <option *ngFor="let item of dcsItems" [value]="item.id">{{ item.label }}</option>
            </select>
            <input-errors [control]="form.controls.dcs" [service]="validationService"></input-errors>
          </div>
        </div>
        <div class="tab-pane fade" id="pills-udh" role="tabpanel" aria-labelledby="udh-tab">
          <div class="alert alert-primary" role="alert">
            When testing UDH, you need to specify the fields in hexadecimal (HEX). Each UDH field includes a
            Tag and Value, and the platform calculates the Length automatically.
            <br /><br />Please note that for concatenated (multi-part) SMS, the manually set UDH will be
            combined with automatically generated UDH fields required for concatenation.
          </div>
          <div class="mb-20">
            <h5 class="mb-20">
              UDH Fields
              <span class="icon-help-1" [tooltip]="
                                    'Each UDH field has a `Tag`, a `Length`, and a `Value`. The `Tag` identifies the type of data, the `Length` specifies the size of the `Value` in octets, and the `Value` is the actual data for the field.'
                                " [tooltipPlacement]="'top'" [tooltipClass]="'text-start'"></span>
            </h5>
            <app-udh-tlv-input #udhListComponent [tagSizeBytes]="1"></app-udh-tlv-input>
          </div>
        </div>
        <div class="tab-pane fade" id="pills-tlv" role="tabpanel" aria-labelledby="tlv-tab">
          <div class="alert alert-primary" role="alert">
            When setting TLV parameters, you need to specify the fields in hexadecimal (HEX).
            <br />Each TLV parameter includes a Tag and Value, and the platform calculates the Length
            automatically.
          </div>
          <div class="mb-20">
            <div class="form-group">
              <label class="form-label">
                Send text as message_payload TLV
                <span class="icon-help-1 text-neutral-n6" [tooltip]="
                                        'Enable this option if you want to send the text of your message as a `message_payload` TLV parameter. <br>This is often used when you need to send special characters or a larger amount of text than a standard SMS can accommodate.'
                                    " [tooltipPlacement]="'top'" [tooltipClass]="'text-start'"></span>
              </label>
              <div class="form-check form-switch">
                <input type="checkbox" class="form-check-input" [(ngModel)]="model.textAsTlv" formControlName="textAsTlv" />
              </div>
            </div>
            <h5 class="mb-20">
              TLV Fields
              <span class="icon-help-1" [tooltip]="
                                    'TLV parameters allow additional information to be included in your SMS. Each TLV comprises of a Tag, a Length, and a Value. These parameters can be used for internal routing purposes.'
                                " [tooltipPlacement]="'top'" [tooltipClass]="'text-start'"></span>
            </h5>
            <app-udh-tlv-input #tlvListComponent [tagSizeBytes]="2"></app-udh-tlv-input>
          </div>
        </div>
        <div class="tab-pane fade" id="pills-timing" role="tabpanel" aria-labelledby="timing-tab">
          <div class="alert alert-primary" role="alert">
            The "Timing and Delivery" settings control when and how your SMS tests are handled by SMSC.
            <br /><br />This includes parameters such as "Time-to-Live" (TTL) for Receipt status, as well as
            "validity_period", "schedule_delivery_time" and "replace_if_present_flag" as per the SMPP
            protocol.
          </div>
          <div class="form-group">
            <label class="form-label">
              TTL Time-to-Live (Receipt status)
              <span class="icon-help-1 text-neutral-n6" [tooltip]="
                                    'TTL Value (Waiting Time Value) determines how long (in minutes) the system will wait for a Final Receipt status for the current test batch before considering it as Negative.<br>This overrides the default TTL value of the (parent) account (60mins by default).'
                                " [tooltipPlacement]="'top'" [tooltipClass]="'text-start'"></span>
            </label>
            <ng-container *ngIf="!isFlashCallMode(); else flashCallTtlTpl">
              <div class="input-group inner-addon right-addon">
                <input [(ngModel)]="model.ttl_min" formControlName="ttl_min" type="text" class="form-control" />
                <span class="input-group-text">min</span>
              </div>
              <input-errors [control]="form.controls.ttl_min" [service]="validationService"></input-errors>
            </ng-container>
            <ng-template #flashCallTtlTpl>
              <input type="text" class="form-control" [value]="flashCallTtlLabel" aria-label="TTL set by flash call detection" disabled />
              <div class="text-neutral-n7 mt-0_5">The TTL is set by flash call detection and cannot be changed.</div>
            </ng-template>
          </div>

          <div class="form-group">
            <label class="form-label">
              Validity Period (SMPP)
              <span class="icon-help-1 text-neutral-n6" [tooltip]="
                                    'The validity_period is an SMPP parameter that indicates to the SMSC expiration time, after which the message should be discarded if not delivered to the destination. <br>If not set, the SMSC applies the default validity period of 24 hours. The default SMPP datetime format is `YYMMDDhhmmsstnnp`. '
                                " [tooltipPlacement]="'top'" [tooltipClass]="'text-start'"></span>
            </label>
            <div class="inner-addon right-addon">
              <input [(ngModel)]="model.validityPeriod" formControlName="validityPeriod" type="text" class="form-control" placeholder="Eg.: 120" />
            </div>
            <input-errors [control]="form.controls.validityPeriod" [service]="validationService"></input-errors>
          </div>

          <div class="form-group">
            <label class="form-label">
              Scheduled Delivery Time (SMPP)
              <span class="icon-help-1 text-neutral-n6" [tooltip]="
                                    'schedule_delivery_time allows you to set a specific time for the SMS to be scheduled for delivery by the SMSC. <br>The format should be: “YYMMDDhhmmsstnnp” (default SMPP datetime format). '
                                " [tooltipPlacement]="'top'" [tooltipClass]="'text-start'"></span>
            </label>
            <div class="inner-addon right-addon">
              <input [(ngModel)]="model.scheduleDeliveryTime" formControlName="scheduleDeliveryTime" type="text" class="form-control"
                placeholder="YYMMDDhhmmsstnnp" />
            </div>
            <input-errors [control]="form.controls.scheduleDeliveryTime" [service]="validationService"></input-errors>
          </div>

          <div class="form-group">
            <label class="form-label">
              Replace If Present Flag
              <span class="icon-help-1 text-neutral-n6" [tooltip]="
                                    'If replace_if_present_flag is set to 1 (enable), it indicates that the submitted message should replace previously submitted message with the same source address, destination address and service type. <br>By default the value is set to 0(disabled).'
                                " [tooltipPlacement]="'top'" [tooltipClass]="'text-start'"></span>
            </label>
            <div class="form-check form-switch">
              <input type="checkbox" class="form-check-input" [(ngModel)]="model.replaceIfPresent" formControlName="replaceIfPresent" />
            </div>
          </div>

          <div class="form-group">
            <label class="form-label">
              Priority Flag
              <span class="icon-help-1 text-neutral-n6"
                tooltip="Designates the priority of the message. The value can range from 0-3. 0 being lowest priority and 3 being the very urgent priority. <br>By default the value is set to 1."
                tooltipPlacement="top" tooltipClass="text-start"></span>
            </label>
            <select [(ngModel)]="model.priority" formControlName="priority" class="form-control form-select input-sm">
              <option *ngFor="let item of priorityOptions" [value]="item">{{ item }}</option>
            </select>
          </div>
        </div>

        <div class="tab-pane fade" id="pills-comment" role="tabpanel" aria-labelledby="comment-tab">
          <div class="alert alert-primary" role="alert">
            This field allows you to leave a comment regarding the current test.
            <br />The comment will be visible to all team members who can view the test entry and it can be
            searched for in the test results.
          </div>
          <div class="form-group">
            <textarea cols="30" rows="8" [(ngModel)]="model.commentText" formControlName="commentText" class="form-control"></textarea>
            <input-errors [control]="form.controls.commentText" [service]="validationService"></input-errors>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer pt-15">
    <div class="button-holder d-flex justify-content-between">
      <button class="btn btn-outline-dark" (click)="dialogRef.close(false)">Cancel</button>
      <button [disabled]="!isSettingsFormValid()" class="btn btn-primary ms-15" (click)="dialogRef.close(true)">
        Confirm
      </button>
    </div>
  </div>
</ng-template>

<ng-template #schedulerCreateModalTpl let-dialogRef="dialogRef">
  <div class="modal-header mb-10">
    <div class="modal-title">
      <h3 class="d-inline-block">Create schedule <span class="icon-help-1 ml-15"></span></h3>
      <button type="button" class="btn-close" (click)="dialogRef.close(true)">
        <span class="icon-close"></span>
      </button>
    </div>
  </div>

  <div class="modal-body">
    <app-scheduler-create (onScheduleAfterSave)="onScheduleAfterSave($event)"></app-scheduler-create>
  </div>
</ng-template>
